import { apiService } from "../../service/ApiService";
import { Redirect, Route } from "react-router-dom";
import React from "react";

const ProtectedRoute = ({ component: Component, path }) => {
  if (apiService.isTokenOk() && window.location.pathname.startsWith("/admin")) {
    return <Route path={path} render={(props) => <Component {...props} />} />;
  }
  return <Redirect to={{ pathname: "/auth/login-page" }} />;
};

export default ProtectedRoute;
